import type { FaireProductEntity } from "../../entity_types/product";

export const p_79hj62vt6k: FaireProductEntity = {
  token: "p_79hj62vt6k",
  type: "product",
  name: "( I181 )  VINTAGE LOVE KNOT EARRING",
  brandToken: "b_r5aqp735w9",
  brandName: "Jewelry Max",
  imageUrl:
    "https://cdn.faire.com/fastly/63e6ad60d2278fe38562a053ff0a6d21a030087ba5d9605eb4491cafbe2efd6e.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.49,
  description:
    "Experience the timeless elegance of our Vintage Love Knot Earrings from Jewelry Max. These classic dangle earrings, measuring 1 1/8 X 1 1/4 inches, embody the perfect blend of sophistication and style. Their intricate love knot design adds a unique touch, making them a must-have addition to your jewelry collection. Whether for a special occasion or everyday wear, these earrings are sure to make a stunning statement. Explore elegance, quality, and style with Jewelry Max.",
  tags: [],
  msrpDollars: 14.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:46.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
